import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import ProductImage from "@/components/ProductImage";
import DropTimer from "@/components/DropTimer";
import { fmt } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  const [picking, setPicking] = useState(false);
  return (
    <div data-testid={`product-card-${product.id}`} className="group relative border-b border-r border-white/10">
      <Link to={`/product/${product.id}`} data-testid={`product-link-${product.id}`} className="block">
        <ProductImage product={product} tag={`N°${String(index + 1).padStart(3, "0")}`} />
      </Link>
      <div className="relative">
        {picking && (
          <div className="absolute bottom-full left-0 right-0 z-10 flex flex-wrap gap-1 border-t border-white/10 bg-ink/95 p-2 backdrop-blur">
            {product.sizes.filter((s) => product.inventory?.[s] === undefined || product.inventory[s] > 0).map((s) => (
              <button
                key={s}
                data-testid={`quick-add-${product.id}-${s}`}
                onClick={() => {
                  addItem(product, s, product.colors[0]);
                  setPicking(false);
                }}
                className="border border-white/20 px-2.5 py-1 font-mono text-[10px] tracking-widest text-bone/80 transition-colors hover:bg-bone hover:text-ink"
              >
                {s}
              </button>
            ))}
          </div>
        )}
        <div className="flex items-start justify-between gap-2 p-4">
          <div className="min-w-0">
            <Link to={`/product/${product.id}`} className="font-display text-sm font-bold uppercase tracking-wide text-bone transition-colors hover:text-white">
              {product.name}
            </Link>
            <p className="mt-1 font-mono text-[10px] tracking-[0.2em] text-fade">{product.colors.join(" / ").toUpperCase()}</p>
            {product.drop_at && new Date(product.drop_at) > new Date() && <DropTimer dropAt={product.drop_at} compact />}
          </div>
          <div className="flex shrink-0 flex-col items-end gap-2">
            <span className="font-mono text-sm text-bone">{fmt(product.price)}</span>
            {product.drop_at && new Date(product.drop_at) > new Date() ? (
              <span data-testid={`quick-add-locked-${product.id}`} className="border border-white/10 px-2.5 py-1.5 font-mono text-[10px] tracking-widest text-fade">
                LOCKED
              </span>
            ) : (
              <button
                data-testid={`quick-add-toggle-${product.id}`}
                onClick={() => setPicking((v) => !v)}
                className="flex items-center gap-1 border border-white/20 px-2.5 py-1.5 font-mono text-[10px] tracking-widest text-bone/80 transition-all hover:border-bone hover:bg-bone hover:text-ink"
              >
                <Plus className="h-3 w-3" /> ADD
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
